import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./C28QualityAssurance.scss"

import { Button, Label, TextArea } from "abs-ui-components";
import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { callApi } from "../../../../../services/MonitoringPlanService.js"
import { emitToasterMsg } from "../../../../../services/toasterUtility.js";
import AutoSave from "../../../../../common/AutoSave/AutoSave.js";

const C28QualityAssurance = forwardRef(({ c28QualityAsuranceEquipment,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    const { dirtyFields } = formState;
    const isC28Dirty = !!(dirtyFields?.c28 && Object.keys(dirtyFields.c28).length > 0);

    useEffect(() => {
        if (c28QualityAsuranceEquipment) {
            reset(prev => ({ ...prev, c28: c28QualityAsuranceEquipment }));
        }
    }, [c28QualityAsuranceEquipment, reset]);

    const filteredFields = cSectionFormFields.filter(
        (field) => field.name !== "formulaeAndDataSources"
    );

    AutoSave(ref, [], async () => {
        if (!isC28Dirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c28");
        const payload = {
            ...filteredFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const c28QualityAssurance = await callApi({
                method: "POST",
                url: API_ROUTES.C28(vesselMstId),
                data: payload,
            });
            if (c28QualityAssurance?.isSuccess) {
                emitToasterMsg("success", "Table C.2.8", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c28: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.2.8", c28QualityAssurance?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.2.8", error.errorMessage);
        }
    };

    return (
        <div className="c28-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Ensuring quality assurance of measuring equipment</h6>
                </MDBCol>
            </MDBRow>

            {filteredFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c28.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c28_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c28_save_btn"
                    disabled={!isC28Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >
                    Save
                </Button>
            </div>
        </div>
    );
});

export default C28QualityAssurance;